import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_array_includes, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__string_pattern } from '@shared/dto/generation/graph_invoke/_enums/ENUM__string_pattern';
import { path_join } from '@shared/utils/utils_path';

declare global {
  interface String {
    capitalize(): string;

    compact_whitespace(): string;

    is_blank(): boolean;

    //prepend slash if not exist
    //remove double slashes
    normalize_path(): string;

    pad(target_length: number): string;

    //error_empty is true by default
    trim_lowercase(error_empty?: boolean): string;

    to_boolean(): boolean;

    remove_string_protocol(): string;

    remove_first_part_of_path(): string;

    split_by_first_entry(character: string): string[];

    only_alphanumeric(): string;

    /*
     *
     */
    is_empty_object_id(): boolean;

    is_object_id(): boolean;

    /*
     *
     */

    is_empty_uuid(): boolean;

    is_empty_hash_sha256(): boolean;

    is_hash_sha256(): boolean;

    /*
     *
     */
    to_base64(): string;
  }
}

String.prototype.capitalize = function (): string {
  if (!this) return this; // Handle empty or null string
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.compact_whitespace = function (): string {
  return this.replace(/\s+/g, ' ').trim();
};

String.prototype.is_blank = function (): boolean {
  return this.trim().length == 0;
};

String.prototype.normalize_path = function (): string {
  let out = path_join('/', this.toString());

  out = out.replace(/\/{2,}/g, '/');

  return out;
};

String.prototype.pad = function (target_length: number): string {
  let out = this.toString();

  // If the input string is less than 6 characters, pad it with spaces
  if (out.length < target_length) {
    const spacesToAdd = target_length - out.length;
    return ' '.repeat(spacesToAdd) + out; // Add spaces at the start
  }

  // Return the input string if it's already 6 characters or longer
  return out;
};

String.prototype.trim_lowercase = function (error_empty: boolean = true): string {
  let out = this.toLowerCase();
  out = out.trim();

  if (error_empty) assert_string_not_empty(out);

  return out;
};

String.prototype.to_boolean = function (): boolean {
  let value = this.trim_lowercase();

  assert_array_includes(['true', 'false'], value, { value, assert_type: ENUM__error_type.VALIDATION_INVALID_TYPE });

  return value == 'true';
};

String.prototype.remove_string_protocol = function (): string {
  if (!this.includes(':')) return this.toString();

  return this.split(':')[1];
};

String.prototype.remove_first_part_of_path = function (): string {
  if (!this.includes('/')) return this.toString();

  return this.split('/')[1];
};

String.prototype.split_by_first_entry = function (character: string): string[] {
  const index: number = this.indexOf(character);

  if (index === -1) return [this] as string[];

  const part_0: string = this.slice(0, index);
  const part_1: string = this.slice(index + 1);

  let out: string[] = [part_0, part_1];

  return out;
};

String.prototype.only_alphanumeric = function (): string {
  return this.replace(/[^\p{L}\p{N}\s]+/gu, '')
    .replace(/\s+/g, ' ')
    .trim();
};

/*
 *
 */
String.prototype.is_empty_object_id = function (): boolean {
  return this.remove_string_protocol() == ENUM__string_id_empty.OBJECT_ID;
};

String.prototype.is_object_id = function (): boolean {
  let [source, flags] = ENUM__string_pattern.OBJECT_ID;

  let pattern = new RegExp(source, flags);

  return pattern.test(this.toString());
};

/*
 *
 */
String.prototype.is_empty_uuid = function (): boolean {
  return this.remove_string_protocol() == ENUM__string_id_empty.UUID_WITHOUT_PROTOCOL;
};

String.prototype.is_empty_hash_sha256 = function (): boolean {
  return this.remove_string_protocol() == ENUM__string_id_empty.HASH_SHA256_WITHOUT_PROTOCOL;
};

String.prototype.is_hash_sha256 = function (): boolean {
  let [source, flags] = ENUM__string_pattern.HASH_SHA256;

  let pattern = new RegExp(source, flags);

  return pattern.test(this.toString());
};
/*
 *
 */

String.prototype.to_base64 = function (): string {
  let out = Buffer.from(this).toString('base64');

  out = `base64:${out}`;

  return out;
};

export {}; // This ensures TypeScript treats it as a module
